import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useBoolean, useDebounceCallback } from 'usehooks-ts';
import { Box, Button } from '@mui/material';

import { componentsSize } from 'constants/components';
import { DEBOUNCE_DELAY } from 'constants/debounce';
import { Input } from 'components/simple';

const styles = {
  copyButton: ({ breakpoints }) => ({
    position: 'absolute',
    right: 20,
    bottom: 10,
    [breakpoints.up('md')]: {
      height: 40,
      bottom: 6,
    },
  }),
  copyButtonClicked: ({ palette }) => ({
    backgroundColor: palette.common.white,
    '&:hover': {
      backgroundColor: palette.common.white,
    },
  }),
  input: ({ breakpoints }) => ({
    '.MuiInputBase-input': {
      paddingRight: '95px !important',
      textOverflow: 'ellipsis',
      [breakpoints.up('md')]: {
        paddingRight: '120px !important',
      },
    },
  }),
};

export const CopyInput = ({ value, label, id, withHiddenLabel = false, customStyles = {} }) => {
  const { value: isCopied, setFalse: setIsCopiedFalse, setTrue: setIsCopiedTrue } = useBoolean();
  const resetIsCopied = useDebounceCallback(setIsCopiedFalse, DEBOUNCE_DELAY.INPUT_RESET);

  const handleCopyToClipboard = () => {
    setIsCopiedTrue();
    resetIsCopied();
  };

  return (
    <Box position="relative" sx={customStyles}>
      <Input
        readOnly
        id={id}
        label={label}
        value={value}
        withHiddenLabel={withHiddenLabel}
        customStyles={{ input: styles.input }}
      />
      <CopyToClipboard text={value} onCopy={handleCopyToClipboard}>
        <Button
          variant={isCopied ? 'outlined' : 'contained'}
          size={componentsSize.small}
          sx={[styles.copyButton, isCopied && styles.copyButtonClicked]}
        >
          {isCopied ? 'Copied' : 'Copy'}
        </Button>
      </CopyToClipboard>
    </Box>
  );
};

CopyInput.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  withHiddenLabel: PropTypes.bool,
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};
